﻿export interface ICenterNotification {
    id: number;
    centerId: number;
    centerAlias: string;
    isEnabled: boolean;
    isRead: boolean;
    readDateTime: string;
    readByUserId: number;
    readByUser: string;
    description: string;
    notificationText: string;
    notificationTypeId: number;
    addedDateTime: string;
}
